import React from 'react';
import {WeaSearchGroup, WeaFormItem, WeaInput} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';
import ELinkMode from './base/ELinkMode';

// 登录系统元素
export default class Content_login extends React.Component {
    render() {
        return (
            <div>
                <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <EType ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ref="eTitle" eid={this.props.eid} value={this.props.eTitle}/> : ''}
                    <ELinkMode ref="eLinkMode" options={this.props.eLinkMode.options} value={this.props.eLinkMode.selected}/>
                </WeaSearchGroup>
            </div>
        );
    }

    getSaveValues() {
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            eContentLinkMode: this.refs['eLinkMode'].getSaveValues(),
        };
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_login.js